import { getTimeFromDate } from './getTimeFromDate';
import { parseTimeToDate } from './parseTimeToDate';
export var getLocalTime = function getLocalTime(time, timezoneDiff) {
  var date = parseTimeToDate(time);
  date.setMinutes(date.getMinutes() - timezoneDiff);
  return getTimeFromDate(date);
};